export const container = '1800px'
export const maxWidth = '1140px'

export const mobileNav = '70px'

export const xPaddingMain = '60px'
export const xPaddingSmallest = '25px'
